var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading-component',{attrs:{"value":_vm.loading}}),_c('div',{attrs:{"id":"map"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }